import React, {useState} from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { ImUser } from 'react-icons/im';
import { FaCalendarAlt } from 'react-icons/fa';
import RunningTrackNavBar from './RunningTrackNavBar';
import RunningTrackAdsComponent from './RunningTrackAdsComponent';
import RunningTrackNoticeComponent from './RunningTrackNoticeComponent';
import RunningTrackRaceModeComponent from './RunningTrackRaceModeComponent';
import RunningTrackSettingComponent from './RunningTrackSettingComponent';

const Wrapper = styled.div``;

const InnerWrapper = styled.div`
  padding: 0 0 3rem 0;
`;
const BtnBox =styled.div`
  width: 100%;
  text-align: right;

  & button {
    border: none;
    border-radius: .2rem;
    padding: 5px 20px;
    font-weight: bold;
    background-color: ${palette.webCyan[5]};
    color: #fff;
    font-size: 1rem;
    margin-bottom: 20px;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }
`;

const StatisticsTab = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  border: 1px solid #A5CBFF;
  border-radius: .3rem;
  height: 55px;
  margin-bottom: 35px;
  overflow: hidden;
`;

const TabItem = styled.li`
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  color: #5F9DF0;
  background-color: #fff;
  cursor: pointer;

  & svg {
    font-size: 1.5rem;
    margin-right: 20px;
    padding-bottom: 3px;
  }

  &.active {
    background-color: #5F9DF0;
    color: #fff;
  }
`;

const RunningTrackComponent = ({
    mainAds,
    bannerAds,
    sideAds,
    pointActive,
    shortRacePointData,
    longRacePointData,
    shortRaceGiftPointData,
    longRaceGiftPointData,
    onDelete,
    onAdd,
    onEdit,
    onEditPoint,
    onChangePointActive,
    onAddPointSetting,
    onDeletePointSetting,
    onUpdatePointSetting,
    originalShortRacePointData,
    originalLongRacePointData,
    originalShortRaceGiftPointData,
    originalLongRaceGiftPointData,
    originalPointActive,
    onOpenMusicPlayer,
}) => {
    const [page, setPage] = useState("ads")

    const selectPage = () => {
      switch(page) {
        case "race" : {
          {/* 상금은 경기마다 지정한다. 지급을 멈추려면 그 경기의 상금을 0 으로 두면 되므로
              클럽 단위 상금표도, 전체 on/off 스위치(pointActive)도 쓰지 않는다.
              상세: docs/race/제타트랙_레이스모드_작업계획서.md §3.2 */}
          return <RunningTrackRaceModeComponent />
        }
        case "notice" : {
          return <RunningTrackNoticeComponent />
        }
        case "setting" : {
          return <RunningTrackSettingComponent />
        }
        case "ads" : {
          return <RunningTrackAdsComponent
            mainAds={mainAds}
            bannerAds={bannerAds}
            sideAds={sideAds}
            onDelete={onDelete}
            onAdd={onAdd}
            onEdit={onEdit}
          />
        }
        // case "banner" : {
        //   return 
        // }
        // case "landing" : {
        // return
        // }
      }
    }
  return (
    <Wrapper>
        <BtnBox>
          <button type="button" onClick={onOpenMusicPlayer}>
            음악 재생
          </button>
        </BtnBox>
        <RunningTrackNavBar setPage={setPage} page={page}/>
        {selectPage()}
    </Wrapper>
  );
};

export default RunningTrackComponent;
